/**
 * @typedef {Object} ClientSelectorTreeViewDtoType
 * @property {number} id - Unique identifier
 * @property {string} name
 * @property {boolean} locked - Disables node and children
 * @property {string[]} locations
 */

/**
 * @class
 */
export default class ClientSelectorTreeViewDto {
  /**
   * Create a new ClientSelectorTreeViewDto.
   * @param {...ClientSelectorTreeViewDtoType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
    this.locked = params.locked
    this.locations = params.locations
  }
}
